
import * as React from 'react';
import { v4 as uuidv4 } from "uuid";
import VideoPlayer from "@/ReactInit/Scripts/VideoPlayer/player";

type Video = {
    Title: string
    YouTubeUrl: string
}

type VideoListProps = {
    videos: string
    title: string
}

const VideoList: React.FC<VideoListProps> = (props) => {

    let parsedVideos: Video[] = [];
    try {
        parsedVideos = JSON.parse(props.videos)
    } catch (e) {
        console.error("Kunne ikke parse videos:", e)
    }
    
    return (
        <>
            {parsedVideos.map((video: Video) => (
                <div key={uuidv4()} className='mb-6'>
                    <div className='max-w-[680px] mx-auto'>
                        <h2 className="font-semibold text-lg mb-1">{video.Title}</h2>
                        <VideoPlayer YouTubeUrl={video.YouTubeUrl} />                        
                    </div>
                </div>
            ))}
        </>
    );
};

export default VideoList;
